import { Filter } from 'src/app/shared/grid/baseGrid.component';

export function parseDrillDownFilters(raw: unknown): Filter | null {
  if (typeof raw !== 'string') return null;
  try {
    const parsed: unknown = JSON.parse(raw);
    return typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed) ? (parsed as Filter) : null;
  } catch {
    return null;
  }
}

export function canonicalizeDrillDownFilterKeys<V extends Filter[string]>(filters: Record<string, V>, canonicalKeys: readonly string[]): Record<string, V> {
  const canonicalByLowerCaseKey = new Map(canonicalKeys.map((key) => [key.toLowerCase(), key]));

  return Object.entries(filters).reduce<Record<string, V>>((canonicalized, [key, value]) => {
    canonicalized[canonicalByLowerCaseKey.get(key.toLowerCase()) ?? key] = value;
    return canonicalized;
  }, {});
}
